import type React from 'react'
import type { KycStatus } from '../types/coreApi-types'
import InfoBox, { type InfoBoxColorscheme } from './InfoBox'

interface KycStatusProps {
  kycStatus: KycStatus | 'Suspended' | 'N/A'
  ignoreKyc?: boolean
}

const KycStatusBox: React.FC<KycStatusProps> = ({ kycStatus, ignoreKyc }) => {
  const getStyle = (): InfoBoxColorscheme => {
    switch (kycStatus) {
      case 'Processing':
      case 'Pending':
        return 'orange'
      case 'Completed':
      case 'Approved':
        return 'green'
      case 'Declined':
      case 'Suspended':
        return 'red'
      case 'N/A':
        return 'gray'
    }
    return 'gray'
  }

  return (
    <InfoBox colorScheme={getStyle()} className="text-xs">
      {ignoreKyc ? '' : 'KYC'} {kycStatus}
    </InfoBox>
  )
}

export default KycStatusBox
